import React, { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import { useLanguageContext } from "../context/languageContext";
import "./styles/languageSlide.css";
import Icon from "@mdi/react";
import { mdiWeb } from "@mdi/js";
import { isRtl } from "../global/isRtl";

function LanguageSlide({ closeMobileMenu = () => {} }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (event) => {
    event.preventDefault();
    setShow(true);
  };

  const { t, languages, onClickLanguageChange } = useLanguageContext();
  const offCanvasPlacement = isRtl() ? "start" : "end";

  // Handler for clicking a language option
  const handleLanguageClick = (lng) => (event) => {
    event.preventDefault();
    onClickLanguageChange(lng);
    handleClose();
    closeMobileMenu(); // Close the mobile menu if the prop is passed
  };

  return (
    <>
      <li>
        <a href="/" onClick={handleShow}>
          <Icon path={mdiWeb} size={0.8} />
        </a>
      </li>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement={offCanvasPlacement}
        className="language-slide"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h3>{t("translations.chooseLang")}</h3>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p>{t("translations.langDesc")}</p>
          <hr />
          <div className="language-options">
            {Object.keys(languages).map((lng) => (
              <Button key={lng} onClick={handleLanguageClick(lng)}>
                {languages[lng].nativeName}
              </Button>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default LanguageSlide;
